import classNames from 'classnames';
import { GatsbyLinkProps, Link as GatsbyLink } from 'gatsby';
import React, { ButtonHTMLAttributes, PropsWithoutRef } from 'react';

import { ReactComponent as RightArrow } from '../../assets/right-arrow.svg';
import { ReactComponent as SpinnerIcon } from '../../assets/spinner.svg';
import {
	button,
	large as largeStyle,
	link as linkStyle,
	noArrow as noArrowStyle,
	spinner as spinnerStyle,
} from './style.module.css';

const isNotGatsbyLinkType = <TState,>(
	props: NonLinkButtonProps | ButtonProps<TState>
): props is NonLinkButtonProps => !('to' in props);

export interface ButtonProps<TState> extends PropsWithoutRef<GatsbyLinkProps<TState>> {
	large?: boolean;
	noArrow?: boolean;
	link?: boolean;
}

export interface NonLinkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	to?: never;
	large?: boolean;
	noArrow?: boolean;
	loading?: boolean;
	link?: boolean;
}

export const Button = <TState,>(props: ButtonProps<TState> | NonLinkButtonProps): JSX.Element => {
	if (isNotGatsbyLinkType<TState>(props)) {
		const { children, noArrow, large, loading, link, ...buttonProps } = props;
		return (
			<button
				className={classNames(
					large && largeStyle,
					noArrow && noArrowStyle,
					link && linkStyle,
					button
				)}
				{...buttonProps}
				disabled={buttonProps.disabled || loading}
			>
				{loading ? (
					<span className={spinnerStyle}>
						<SpinnerIcon />
					</span>
				) : (
					<>
						{!!children && <span>{children}</span>}
						{noArrow || <RightArrow />}
					</>
				)}
			</button>
		);
	}

	const { children, noArrow, large, link, ...linkProps } = props;
	return (
		<GatsbyLink
			className={classNames(
				large && largeStyle,
				noArrow && noArrowStyle,
				link && linkStyle,
				button
			)}
			{...linkProps}
		>
			{!!children && <span>{children}</span>}
			{noArrow || <RightArrow />}
		</GatsbyLink>
	);
};
